import React from 'react';
import {MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody} from 'mdb-react-ui-kit';
import {Button} from 'react-bootstrap';
/**
 *  L'accueil
 * @return {JSX}
 */
function TacheUpdateView(props) {
  return (
    <MDBContainer className="modal" fluid>
          <MDBRow className="d-flex justify-content-center align-items-center h-100 banktable-modal-content" style={{marginTop: '100px'}}>
            <MDBCol col="12">
              <MDBCard className="bg-dark text-white my-5 mx-auto align-items-center" style={{borderRadius: '1rem', maxWidth: '800px'}}>
                <span className="employe-close" onClick={props.closeModal} style={{marginRight: '20px', marginTop: '10px'}}>
                &times;
                </span>
                  <h2 className="fw-bold mb-2 text-uppercase" style={{marginTop: '30px'}}>{props.isUpdate ? 'Modifier la tache' : 'Ajouter une tache'}</h2>
                <MDBCardBody className="mx-auto w-100 employer-padding">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Nom de la tache"
                    value={props.inputValue}
                    onChange={(e) => props.setInputValue(e.target.value)} />
                  {props.errors !== '' && (
                    <span className="error">{props.errors}</span>
                  )}
                  <div style={{display:"flex", justifyContent:"center", alignItems:"center", marginTop:"15px"}}>
                    <input type="color" id="body" name="body"
                        onChange={(e) => props.setColor(e.target.value)}
                       value={props.color} />
                      <label htmlFor="body"> Couleur de la tâche</label>
                    </div>
                  <Button
                    color="white"
                    size="lg"
                    style={{
                      color: 'white',
                      fontSize: 'calc(10px + 2vmin)',
                      backgroundColor: '#363E46',
                      border: 'none',
                      width: '100%',
                      marginTop:"15px",
                    }}
                    onClick={() => props.handleSubmit()}>
                    Enregistrer
                  </Button>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
  );
}

export default TacheUpdateView;